<template>
  <v-dialog v-model="dialog" persistent max-width="30vw" class="rounded-lg">
    <v-card>
      <v-card-title class="text-h5" v-if="isNeerToExpire">
        La sesión está apunto de expirar
      </v-card-title>
      <v-card-title class="text-h5" v-else>
        La sesión ha expirado
      </v-card-title>
      <v-card-text>
        <v-form ref="form" class="pb-5">
          <v-row justify="center" v-if="isNeerToExpire">
            <v-col>
              <span> Ingresa tus credenciales para verificar tu sesión</span>
            </v-col>
          </v-row>
          <v-row justify="center" v-else>
            <v-col>
              <span>
                Vuelve a iniciar sesión para ingresar nuevamente a la
                plataforma</span
              >
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="10" md="10">
              <v-text-field
                v-model="email"
                dense
                label="Correo"
                :rules="emailRules"
                required
                clearable
                outlined
                :disabled="isLoading"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="mt-0">
            <v-col cols="10" md="10">
              <v-text-field
                v-model="password"
                dense
                :rules="passwordRules"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                label="Contraseña"
                @click:append="showPassword = !showPassword"
                required
                outlined
                clearable
                :disabled="isLoading"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                v-if="!isNeerToExpire"
                color="green darken-1"
                block
                @click="logOut"
                :disabled="isLoading"
                :loading="isLoadingLogOut"
                dark
              >
                Salir
              </v-btn>
              <v-btn v-else color="gray" block @click="dialog = false" dark>
                Cerrar
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="singIn"
                :loading="isLoading"
                :disabled="isLoadingLogOut"
              >
                Verificar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
// Validations
import { requiredFValidation, emailValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    email: "",
    password: "",
    showPassword: false,
    emailRules: emailValidation(true, "correo electrónico"),
    passwordRules: requiredFValidation("contraseña"),
    checkRules: [(v) => v == 1 || "Debes aceptar los términos para continuar"],
    isLoading: false,
    isLoadingLogOut: false,
  }),
  props: {
    value: Boolean,
  },
  methods: {
    ...mapActions("session", ["logout", "login"]),
    ...mapMutations("session", ["SET_LOG_OUT"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async logOut() {
      this.isLoadingLogOut = true;
      await this.logout({
        refreshToken: localStorage.getItem("refresh_token"),
        session: localStorage.getItem("session"),
      });
      this.SET_LOG_OUT();
      this.isLoadingLogOut = false;
      this.$router.push("/login");
      this.dialog = false;
    },
    async singIn() {
      try {
        if (this.$refs.form.validate()) {
          this.isLoading = true;

          await this.logout({
            refreshToken: localStorage.getItem("refresh_token"),
            session: localStorage.getItem("session"),
          });

          const response = await this.login({
            email: this.email,
            password: this.password,
          });

          if (response.error) throw response;

          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Autenticación exitosa !!`,
            timeout: 4000,
          });
          this.$emit("updateTime");
          this.isLoading = false;
          this.dialog = false;
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: `Ocurrio un error en la autenticación, intente de nuevo.`,
          timeout: 4000,
        });
      }
    },
  },
  computed: {
    ...mapState("session", ["isNeerToExpire"]),
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style>
</style>